import { PlayerStatusEnum } from "../types/playerStatusEnum";
import { RoleClassEnum } from "../types/roleClassEnum";
import { MAFIA_ROLE_GROUPS, MAFIA_ROLES, NEUTRAL_ROLE_GROUPS, NEUTRAL_ROLES, TOWN_ROLE_GROUPS, TOWN_ROLES } from "../types/roleEnum";
import React from 'react';

export default class ScenarioUtils {

    public static CheckRole(roleString: string): RoleClassEnum {
        let roleEnumCounter = 0;

        for (let role of TOWN_ROLE_GROUPS.concat(TOWN_ROLES)) {
            if (roleString.indexOf(role) !== -1) {
                roleEnumCounter += 1;
                break;
            }
        }

        for (let role of MAFIA_ROLES.concat(MAFIA_ROLE_GROUPS)) {
            if (roleString.indexOf(role) !== -1) {
                roleEnumCounter += 2;
                break;
            }
        }

        for (let role of NEUTRAL_ROLES.concat(NEUTRAL_ROLE_GROUPS)) {
            if (roleString.indexOf(role) !== -1) {
                roleEnumCounter += 4;
            }
        }

        if (roleEnumCounter === 1) return RoleClassEnum.Town;
        if (roleEnumCounter === 2) return RoleClassEnum.Mafia;
        if (roleEnumCounter === 4) return RoleClassEnum.Neutral;
        return RoleClassEnum.Mixed;
    }

    public static GetRoleClass(roleString: string): 'mafia' | 'town' | 'neutral' | 'mixed' {
        const role = this.CheckRole(roleString);

        switch (role) {
            case RoleClassEnum.Mafia: return 'mafia';
            case RoleClassEnum.Neutral: return 'neutral';
            case RoleClassEnum.Mixed: return 'mixed';
            default: return 'town';
        }
    }

    public static CalculateRoleSetup(raw_scenario: string[]): { town: number, mafia: number, neutral: number, mixed: number } {
        return raw_scenario.reduce((acc, curr) => {
            switch (this.CheckRole(curr)) {
                case RoleClassEnum.Town:
                    return {
                        ...acc,
                        town: acc.town + 1,
                    }
                case RoleClassEnum.Mafia:
                    return {
                        ...acc,
                        mafia: acc.mafia + 1,
                    }
                case RoleClassEnum.Neutral:
                    return {
                        ...acc,
                        neutral: acc.neutral + 1,
                    }
                default:
                    return {
                        ...acc,
                        mixed: acc.mixed + 1,
                    }
            }

        }, { town: 0, mafia: 0, neutral: 0, mixed: 0 });
    }

    public static GetOtherPlayerStatus(isSelf: boolean, playerRole: RoleClassEnum, isPlayerDead: boolean, otherPlayerRole: string, isOtherPlayerDead: boolean): PlayerStatusEnum {
        //you can see yourself  
        if(isSelf) {
            return PlayerStatusEnum.Visible;
        }
        
        if(otherPlayerRole.toLowerCase() === 'unknown'){ 
            return PlayerStatusEnum.Hidden;
        }

        //everyone can see dead people
        if(isOtherPlayerDead) {
            return PlayerStatusEnum.Dead;
        }

        //dead people can see everyone
        if(isPlayerDead) {
            return PlayerStatusEnum.Visible;
        }

        //mafia can see mafia
        const isMafia = playerRole === RoleClassEnum.Mafia;
        if(isMafia) {
            const isOtherPlayerMafia = this.CheckRole(otherPlayerRole) === RoleClassEnum.Mafia;
            if(isOtherPlayerMafia){
                return PlayerStatusEnum.Mafia;
            }
        }
        return PlayerStatusEnum.Hidden;
    }
}